import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgGenderMix({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M12.2 5.83h3.02c.38 0 .7.28.75.64v3.2a.75.75 0 01-1.49.1V8.46l-1.63 1.84c.31.52.51 1.12.54 1.76l.01.2a3.75 3.75 0 11-1.58-3.06l1.64-1.86H12.2a.75.75 0 01-.74-.65v-.1c0-.38.28-.7.64-.75h3.13zm-2.55 4.1a2.32 2.32 0 100 4.64 2.32 2.32 0 000-4.64zM3.75 0a3.75 3.75 0 01.75 7.43v1.23h1.42c.38 0 .7.29.74.65v.1c0 .38-.27.7-.64.75H4.5v1.5c0 .38-.28.7-.65.74h-.1a.75.75 0 01-.74-.64l-.01-.1v-1.5H1.55a.75.75 0 01-.74-.65l-.01-.1c0-.38.28-.69.65-.74H3V7.41A3.75 3.75 0 013.75 0zm0 1.43a2.32 2.32 0 100 4.64 2.32 2.32 0 000-4.64z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgGenderMix.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgGenderMix.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgGenderMix svgRef={ref} {...props} />);
export default ForwardRef;
